var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/money-time"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0001 26.5834C24.5314 26.5834 26.5834 24.5314 26.5834 22.0001C26.5834 19.4688 24.5314 17.4167 22.0001 17.4167C19.4688 17.4167 17.4167 19.4688 17.4167 22.0001C17.4167 24.5314 19.4688 26.5834 22.0001 26.5834Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.9167 17.4167V26.5834",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16659 40.3334C13.2167 40.3334 16.4999 37.0502 16.4999 33.0001C16.4999 28.95 13.2167 25.6667 9.16659 25.6667C5.1165 25.6667 1.83325 28.95 1.83325 33.0001C1.83325 37.0502 5.1165 40.3334 9.16659 40.3334Z",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.62492 30.7085V32.4135C9.62492 33.0551 9.29494 33.6601 8.7266 33.9901L7.33325 34.8335",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.66675 27.8666V16.4999C3.66675 10.0833 7.33341 7.33325 12.8334 7.33325H31.1667C36.6667 7.33325 40.3334 10.0833 40.3334 16.4999V27.4999C40.3334 33.9166 36.6667 36.6666 31.1667 36.6666H15.5834",
    stroke: "#AEB1D2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTime);
export default __webpack_public_path__ + "static/media/money-time.7b07c3fd7aaa2c80f8e5d67e89b09787.svg";
export { ForwardRef as ReactComponent };